import { render } from "./EasyReceipt_Page.vue?vue&type=template&id=1b262910&scoped=true"
import script from "./EasyReceipt_Page.vue?vue&type=script&lang=js"
export * from "./EasyReceipt_Page.vue?vue&type=script&lang=js"

import "./EasyReceipt_Page.vue?vue&type=style&index=0&id=1b262910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b262910"]])

export default __exports__